<template>
    <div v-if="dataFound" class="top-10-products-container-background">
        <div class="row">
            <div class="top-10-products-container w-100">
                <div class="top-10-container">
                    <div class="top-10-product velmld-parent top-10-title">
                        <div class="top-10-title-content">
                            <div class="top-10-title-content">
                                <div class="top-label-container">
                                    <h2 class="top-label">TOP</h2>
                                    <h2 class="ten-label">10</h2>
                                </div>
                            </div>
                            <div class="top-10-headline">
                                <h3>{{ headline }}</h3>
                                <p>{{ headlineText }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <c-home-top-10-product
                    :loading="top10Loading"
                    title="No Brasil"
                    type="top-brasil"
                    :key="topBrasilProduct.id"
                    :productName="topBrasilProduct.name"
                    :productRef="topBrasilProduct.ref"
                    :productImage="topBrasilProduct.image"
                    :productLink="topBrasilProduct.link"
                    :productPrice="topBrasilProduct.price"
                    :productPromotionalPrice="topBrasilProduct.promotionalPrice"
                    :productQuantityPackaging="topBrasilProduct.quantityPackaging"
                    :productHavePromotion="topBrasilProduct.havePromotion"
                    :productId="topBrasilProduct.id"
                    :allProductsLink="catalogTopBrazil"
                    :isCustomerTypeSale="isCustomerTypeSale"
                    :productBlockedStatus="topBrasilProduct.blockedStatus"
                    />
                <c-home-top-10-product
                    :loading="top10Loading"
                    title="No seu estado"
                    type="top-estado"
                    :key="topStateProduct.id"
                    :productName="topStateProduct.name"
                    :productRef="topStateProduct.ref"
                    :productImage="topStateProduct.image"
                    :productLink="topStateProduct.link"
                    :productPrice="topStateProduct.price"
                    :productPromotionalPrice="topStateProduct.promotionalPrice"
                    :productQuantityPackaging="topStateProduct.quantityPackaging"
                    :productHavePromotion="topStateProduct.havePromotion"
                    :productId="topStateProduct.id"
                    :allProductsLink="catalogTopState"
                    :isCustomerTypeSale="isCustomerTypeSale"
                    :productBlockedStatus="topStateProduct.blockedStatus"
                    />
                <c-home-top-10-product
                    :loading="top10Loading"
                    title="Neste mês"
                    type="top-mes"
                    :key="topMonthProduct.id"
                    :productName="topMonthProduct.name"
                    :productRef="topMonthProduct.ref"
                    :productImage="topMonthProduct.image"
                    :productLink="topMonthProduct.link"
                    :productPrice="topMonthProduct.price"
                    :productPromotionalPrice="topMonthProduct.promotionalPrice"
                    :productQuantityPackaging="topMonthProduct.quantityPackaging"
                    :productHavePromotion="topMonthProduct.havePromotion"
                    :productId="topMonthProduct.id"
                    :productBlockedStatus="topMonthProduct.blockedStatus"
                    :allProductsLink="catalogTopMonth"
                    :isCustomerTypeSale="isCustomerTypeSale"
                    />
            </div>
        </div>
    </div>
</template>
<script>

const defaultProductInformation = {
    name: '',
    ref: '',
    image: APP_URL + '/public/images/not-found/230-264/230-264.jpg',
}

export default {
	props: [
        'catalogTopBrazil',
        'catalogTopState',
        'catalogTopMonth',
        'isCustomerTypeSale',
    ],
	data() { return {
        top10Loading: true,
        headline: '',
        headlineText: '',
        topBrasilProduct: { ...defaultProductInformation },
        topStateProduct: { ...defaultProductInformation },
        topMonthProduct: { ...defaultProductInformation },
        dataFound: false,
    } },
	methods: {
        fetchHeadlineInformation() {
            this.axios.get(API_URL + '/home/headline-information')
				.then(({ data }) =>
				{
                    this.headline = data.headline
                    this.headlineText = data.headlineText
				}
			)
        },
        fetchTopProducts() {
            const vm = this
            this.axios.get(API_URL + '/home/top-products')
				.then(({ data }) =>
				{   
                    if(!data.top_brazil && !data.top_state && !data.top_month) {
                        return
                    }

                    this.dataFound = true

                    vm.topBrasilProduct.id = data.top_brazil.id
                    vm.topBrasilProduct.name = data.top_brazil.name
                    vm.topBrasilProduct.ref = data.top_brazil.ref
                    vm.topBrasilProduct.image = data.top_brazil.image
                    vm.topBrasilProduct.link = data.top_brazil.link
                    vm.topBrasilProduct.price = data.top_brazil.price
                    vm.topBrasilProduct.promotionalPrice = data.top_brazil.promotional_price
                    vm.topBrasilProduct.quantityPackaging = data.top_brazil.quantity_packaging
                    vm.topBrasilProduct.havePromotion = data.top_brazil.have_promotion
                    vm.topBrasilProduct.blockedStatus = data.top_brazil.blocked_status

                    vm.topStateProduct.id = data.top_state.id
                    vm.topStateProduct.name = data.top_state.name
                    vm.topStateProduct.ref = data.top_state.ref
                    vm.topStateProduct.image = data.top_state.image
                    vm.topStateProduct.link = data.top_state.link
                    vm.topStateProduct.price = data.top_state.price
                    vm.topStateProduct.promotionalPrice = data.top_state.promotional_price
                    vm.topStateProduct.quantityPackaging = data.top_state.quantity_packaging
                    vm.topStateProduct.havePromotion = data.top_state.have_promotion
                    vm.topStateProduct.blockedStatus = data.top_state.blocked_status
                    
                    vm.topMonthProduct.id = data.top_month.id
                    vm.topMonthProduct.name = data.top_month.name
                    vm.topMonthProduct.ref = data.top_month.ref
                    vm.topMonthProduct.image = data.top_month.image
                    vm.topMonthProduct.link = data.top_month.link
                    vm.topMonthProduct.price = data.top_month.price
                    vm.topMonthProduct.promotionalPrice = data.top_month.promotional_price
                    vm.topMonthProduct.quantityPackaging = data.top_month.quantity_packaging
                    vm.topMonthProduct.havePromotion = data.top_month.have_promotion
                    vm.topMonthProduct.blockedStatus = data.top_month.blocked_status
                    
				}
			).finally(() => {
                this.top10Loading = false
            })
        }
    },
    mounted() {
        this.fetchHeadlineInformation()
        this.fetchTopProducts()
    }
}
</script>